export default "__VITE_ASSET__$GL519V9__"